import React from 'react';
import { makeStyles } from '@material-ui/styles';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Link as LinkScroll } from 'react-scroll';
import './HeroLayer2.scss';

const routeVideo = '/video/video-contacta.mp4';

const useStyles = makeStyles({
  linkStyle: {
    '@media screen and (max-width: 619.98px)': {
      minWidth: '100%',
    }
  },
  buttonStyle: {
    minWidth: 284,
    '@media screen and (max-width: 619.98px)': {
      minWidth: 'inherit',
      fontSize: 20,
      height: 48,
    }
  },
  scroll: {
    '@media screen and (max-width: 619.98px)': {
      width: '100%'
    }
  }
})

const HeroLayer = () => {
  const isMobile = useMediaQuery('(max-width: 959.98px)');
  const classes = useStyles()

  const SignUp = () => {
    console.log('Regístrate');
  }

  return (
    <>
      <section className="heroLayer2">
        <div className="heroLayer2-wrapper">
          <div className="heroLayer2-description">
            <p className="heroLayer2-title">
              ¿Qué es Contacta<br />Abogado<small>®</small>?
            </p>
            <p className="heroLayer2-paragraph">
              Somos la plataforma digital que
              reúne a los mejores profesionales en
              Derecho para brindar servicios
              legales a personas y empresas que
              buscan solucionar un problema.
            </p>
            {!isMobile &&
            <LinkScroll to="form" smooth="true" duration={1500} offset={-60}>
              <ButtonBase
                onClick={SignUp}
                linkStyle={classes.linkStyle}
                buttonStyle={classes.buttonStyle}
                variant="secondary"
              >
                ¡Regístrate!
              </ButtonBase>
            </LinkScroll>
            }
          </div>
          <div className="heroLayer2-video_section">
            <p className='heroLayer2-video_paragraph'>Descubre cómo funciona</p>
            <div className="heroLayer2-video_container">
              <video className="heroLayer2-video_movie" controls="0"   poster="/img/lp-300/poster.jpg" controlsList="nodownload" playsInline>
                <source src={routeVideo} type="video/mp4"/>
              </video>
            </div>
            {isMobile &&
              <LinkScroll
                to="form"
                smooth="true"
                duration={1500}
                offset={-60}
                className={classes.scroll}
              >
                <ButtonBase
                  onClick={SignUp}
                  linkStyle={classes.linkStyle}
                  buttonStyle={classes.buttonStyle}
                  variant="secondary"
                >
                  ¡Regístrate!
                </ButtonBase>
              </LinkScroll>
            }
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroLayer;
